/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_Loading_AccountsInputs */

const es_settings_sources_loading_accounts = /** @type {(inputs: Settings_Sources_Loading_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando cuentas...`)
};

const en_settings_sources_loading_accounts = /** @type {(inputs: Settings_Sources_Loading_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading accounts...`)
};

/**
* | output |
* | --- |
* | "Loading accounts..." |
*
* @param {Settings_Sources_Loading_AccountsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_loading_accounts = /** @type {((inputs?: Settings_Sources_Loading_AccountsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_Loading_AccountsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_loading_accounts(inputs)
	return en_settings_sources_loading_accounts(inputs)
});
export { settings_sources_loading_accounts as "settings.sources.loading_accounts" }